export default "__VITE_ASSET__aNQOPN9D__"